import { createListApiSchema } from '../General/schemas';
import { groupSchema } from '../Group/schemas';
import { userSchema } from '../User/schemas';
import z from 'zod';

export const projectSchema = z
	.object({
		id: z.string(),
		name: z.string(),
		description: z.string().optional(),
		startDate: z.coerce.date(),
		endDate: z.coerce.date(),
		adminIds: z.array(z.string()).optional(),
		admins: z.array(z.lazy(() => userSchema)).optional(),
		principalGroups: z.array(
			z.object({
				groupId: z.string(),
				label: z.string(),
			}),
		),
		principalGroupIdsFlat: z.array(z.string()),
		principalGroupsPopulated: z.array(z.lazy(() => groupSchema)),
		zoneIds: z.array(z.string()),
		zones: z
			.array(
				z.lazy(() =>
					z.object({
						id: z.string(),
						name: z.string(),
					}),
				),
			)
			.optional(),
		archived: z.boolean(),
		keywords: z.string(),
	})
	.describe('Project');

const subcontractorSchema = z.object({
	eventId: z.string(),
	eventName: z.string(),
	eventGroupName: z.string(),
	eventGroupId: z.string(),
});

export const projectHierarchySchema = z
	.object({
		principalGroup: z.object({
			eventGroupName: z.string(),
		}),
		subcos: z.array(
			subcontractorSchema.extend({
				subsubcos: z.array(subcontractorSchema).optional(),
			}),
		),
	})
	.describe('Project Hierarchy');

export const projectsApiResponseSchema = createListApiSchema(projectSchema).describe('Projects');
